import React, { useState, useEffect } from 'react'

import { Row, Col } from 'react-bootstrap';
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import { MdLink } from 'react-icons/md';
import { Builders } from '../../';

const ViewDialog = props => {
    const { open, setOpen, selected } = props;
    const [question, setQuestion] = useState(null);

    useEffect(() => {
        if (selected) {
            setQuestion(selected[0]);
        }
    }, [selected])

    const handleClose = () => {
        setOpen(false)
    }

    const renderQuestion = (question) => {
        const qProps = { question };
        return <Builders.Questions.Visualizer {...qProps} dashWidth={30} /> 
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth
        >
            <DialogTitle id="form-dialog-title">Visualize Question</DialogTitle>
            <DialogContent>
            {/* <DialogContentText>Link question to survey.</DialogContentText> */}
                {question && (
                <>
                    <Row className="text-center mt-3">
                        <Col xs={12}>
                            <h6>{question.instructions}</h6>
                            <h6>{question.label}</h6>
                        </Col>
                    </Row>
                    <Row className="mt-3" >
                        <Col xs={12} >
                            {renderQuestion(question)}
                        </Col>
                    </Row>
                </>
                )}
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Close
            </Button>
            </DialogActions>
        </Dialog>
    )
}

ViewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default ViewDialog
